import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBluesky,
  faFacebook,
  faGoogle,
  faInstagram,
  faLinkedin,
  faPinterest,
  faThreads,
  faTiktok,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { cn } from '@/utils/cn';

/** Font Awesome brand logo per platform key (lowercase). Single source for previews. */
export const PLATFORM_FA_ICONS: Record<string, IconDefinition> = {
  linkedin: faLinkedin,
  facebook: faFacebook,
  instagram: faInstagram,
  twitter: faXTwitter,
  youtube: faYoutube,
  tiktok: faTiktok,
  pinterest: faPinterest,
  threads: faThreads,
  google_my_business: faGoogle,
  bluesky: faBluesky,
};

interface PlatformBrandIconProps {
  platform: string;
  className?: string;
}

/** Decorative platform logo; renders nothing for an unknown platform. */
export const PlatformBrandIcon = ({ platform, className }: PlatformBrandIconProps) => {
  const icon = PLATFORM_FA_ICONS[platform.toLowerCase()];
  if (!icon) return null;
  return <FontAwesomeIcon icon={icon} className={cn('shrink-0', className)} aria-hidden="true" />;
};

interface PlatformBadgeProps {
  platform: string;
  className?: string;
}

/** Small circular platform badge: black disc with the white logo. Decorative. */
export const PlatformBadge = ({ platform, className }: PlatformBadgeProps) => {
  const key = platform.toLowerCase();
  if (!PLATFORM_FA_ICONS[key]) return null;
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex h-[18px] w-[18px] aspect-square shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-900 text-white leading-none',
        className
      )}
    >
      <FontAwesomeIcon icon={PLATFORM_FA_ICONS[key]} fixedWidth className="block text-[11px] leading-none" />
    </span>
  );
};
